export default "__VITE_ASSET__bb90ecfc__"